(() => {
  'use strict';
  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;
  const viewport = gallery.querySelector('.gallery-viewport');
  const slides = Array.from(viewport.querySelectorAll('[data-gallery-slide]'));
  const counter = gallery.querySelector('[data-gallery-count]');
  const prev = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  const mobile = matchMedia('(max-width:760px)');
  let index = 0, scrollFrame = null;
  function paint() {
    counter.textContent = String(index + 1).padStart(2, '0') + '/' + String(slides.length).padStart(2, '0');
    counter.setAttribute('aria-label', 'Photo ' + (index + 1) + ' of ' + slides.length);
    prev.disabled = index === 0;
    next.disabled = index === slides.length - 1;
    slides.forEach((slide, i) => { slide.inert = mobile.matches && i !== index; });
    viewport.tabIndex = mobile.matches && slides.length > 1 ? 0 : -1;
  }
  function show(n, instant = false) {
    index = Math.max(0, Math.min(slides.length - 1, n));
    if (mobile.matches) viewport.scrollTo({left: slides[index].offsetLeft, behavior: instant || !window.SevenFortyFive.motion.enabled() ? 'instant' : 'smooth'});
    paint();
  }
  prev.addEventListener('click', () => show(index - 1));
  next.addEventListener('click', () => show(index + 1));
  viewport.addEventListener('keydown', event => {
    if (!mobile.matches) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  viewport.addEventListener('scroll', () => {
    if (!mobile.matches || scrollFrame !== null) return;
    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = null;
      const nearest = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - viewport.scrollLeft) < Math.abs(slides[best].offsetLeft - viewport.scrollLeft) ? i : best, 0);
      if (nearest !== index) { index = nearest; paint(); }
    });
  }, {passive: true});
  mobile.addEventListener('change', () => { viewport.scrollTo({left: 0, behavior: 'instant'}); index = 0; paint(); });
  new ResizeObserver(() => { if (mobile.matches) show(index, true); }).observe(viewport);
  document.addEventListener('745:variantchange', () => show(0, true));
  paint();
  const lightbox = document.querySelector('#product-lightbox');
  const enlarged = lightbox.querySelector('[data-lightbox-image]');
  let origin = null;
  gallery.addEventListener('click', event => {
    const link = event.target.closest('[data-gallery-enlarge]');
    if (!link) return;
    event.preventDefault(); origin = link;
    enlarged.src = link.href;
    enlarged.alt = link.querySelector('img').alt;
    lightbox.showModal(); document.body.classList.add('modal-open');
    lightbox.querySelector('[data-lightbox-close]').focus();
  });
  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('close', () => {
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
    origin?.focus();
  });
  lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
})();
